import Base64 from 'crypto-js/enc-base64';
import sha256 from 'crypto-js/sha256';
import * as openpgp from 'openpgp';

export function encodeStr(str: string): string {
    const hashDigest = sha256(str);

    const encodeStr = Base64.stringify(hashDigest);
    return encodeStr;
}

export function genNonceStr(num = 6): string {
    const strList =
        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let nonce = '';

    for (let i = 0; i < num; i++) {
        const index = Math.floor(Math.random() * strList.length);

        nonce += strList[index];
    }

    return nonce;
}

export function genSignature(nonce: string, timestamp: number): string {
    const key = process.env.REACT_APP_API_KEY;
    const secret = process.env.REACT_APP_API_SECRET;
    const message = `key=${key}&secret=${secret}&timestamp=${timestamp}`;
    return encodeStr(nonce + message);
}

export async function encrypt(
    data: Uint8Array,
    password: string,
): Promise<Uint8Array> {
    const message = await openpgp.createMessage({
        binary: data,
    });

    const encrypted = await openpgp.encrypt({
        message,
        passwords: [password],
        format: 'binary',
    });

    return new Uint8Array(encrypted);
}

export async function decrypt(
    data: Uint8Array,
    password: string,
): Promise<Uint8Array> {
    const message = await openpgp.readMessage({
        binaryMessage: data,
    });

    const decrypted = await openpgp.decrypt({
        message,
        passwords: [password],
        format: 'binary',
    });

    return new Uint8Array(decrypted.data);
}
